import React from 'react';
 
import './stepsPrivacy.css';

function StepsPrivacy(props) {

    return (
        <div className="ghost-steps">
	    {props.logged ?
                <React.Fragment>

                    <div className="ghost-steps-cell" onClick={() => props.setStep(2)}>
                        <span className={props.step !== 2 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>2</span>
                        <span className={props.step !== 2 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                            <span className={props.step !== 2 ? "ghost-step-second" : ""}>Address Book</span>
                        </span>
                    </div>
                    <div className="ghost-steps-line"></div>

                    <div className="ghost-steps-cell" onClick={() => props.setStep(3)}>
                        <span className={props.step !== 3 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>3</span>
                        <span className={props.step !== 3 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                            <span className={props.step !== 3 ? "ghost-step-second" : ""}>Transfer</span>
                        </span>
                    </div>
                    <div className="ghost-steps-line"></div>

                    <div className="ghost-steps-cell" onClick={() => props.setStep(4)}>
                        <span className={props.step !== 4 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>4</span>
                        <span className={props.step !== 4 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                            <span className={props.step !== 4 ? "ghost-step-second" : ""}>Deposit</span>
                        </span>
                    </div>
                    <div className="ghost-steps-line"></div>

                    <div className="ghost-steps-cell" onClick={() => props.setStep(5)}>
                        <span className={props.step !== 5 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>5</span>
                        <span className={props.step !== 5 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                            <span className={props.step !== 5 ? "ghost-step-second" : ""}>Withdraw</span>
                        </span>
                    </div>
                    <div className="ghost-steps-line"></div>

                    <div className="ghost-steps-cell" onClick={() => props.setStep(6)}>
                        <span className={props.step !== 6 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>6</span>
                        <span className={props.step !== 6 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                            <span className={props.step !== 6 ? "ghost-step-second" : ""}>Account</span>
                        </span>
                    </div>
                </React.Fragment>
		:
                <div className="ghost-steps-cell" onClick={() => {props.setStep(1);}}>
                    <span className={props.step !== 1 ? "ghost-steps-cell-number" : "ghost-steps-cell-number-active"}>1</span>
                    <span className={props.step !== 1 ? "ghost-steps-cell-text": "ghost-steps-cell-text-active"}>
                        <span className={props.step !== 1 ? "ghost-step-first" : ""}>Login</span>
                    </span>
                </div>
	    }

        </div>
    )
}

export default StepsPrivacy;
